<div style="margin: 20px;">

  <ng-container>
    <div class="box-container">
      <div class="box-header">
        <span>{{ 'shared.details' | translate }}</span>
      </div>
      <div class="box-item">
        <span class="text-blue-color me-2">{{ 'attachments.unique_attachments' | translate }}: </span>
        <span *ngIf="!isAnalyzing">{{ uniqueAttachments?.size || 0 }} <span *ngIf="incomplete">({{ 'analysis.partial' | translate }})</span></span>
        <span *ngIf="isAnalyzing">{{ 'shared.computing' | translate }}</span></div>

      <div class="box-item" *ngIf="uniqueAttachments?.size > 0">
        <span class="text-blue-color me-2">{{ 'attachments.types_of_extensions' | translate }}: </span>
        <span>{{ getAttachmentTypes() }}</span>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="uniqueAttachments?.size > 0">
    <div *ngFor="let attachment of uniqueAttachments ;let  i = index " class="box-container"
         [id]="'attachmentInfo-'+i">
      <div class="box-header">
        <span>{{ 'attachments.attachment' | translate }} #{{ i + 1 }}</span>
      </div>
      <div class="box-item">
        <span class="text-blue-color">{{ 'attachments.attachment_name' | translate }}</span>
      </div>
      <div class="box-item">
        <span>{{ attachment.name }}</span>
      </div>
      <div class="box-item">
        <span class="text-blue-color me-2">{{ 'attachments.attachment_type' | translate }}:</span>
        <span>{{ attachment.extension | uppercase }}</span>
      </div>
      <div *ngIf="attachment.index">
        <div class="box-item">
          <span class="text-blue-color me-2">{{ 'attachments.concerns_with_this_type_of_file' | translate }}: </span>
        </div>
        <div class="box-item ms-4">
          <ul>
            <li *ngFor="let concern of attachment.index.concerns"> {{ concern }}</li>
          </ul>
        </div>

        <div class="box-item">
            <span class="text-blue-color me-2">{{ 'attachments.best_practices_for_this_type_of_file' | translate }}
              : </span>
        </div>
        <div class="box-item ms-4">
          <ul>
            <li *ngFor="let practice of attachment.index.bestPractice"> {{ practice }}</li>
          </ul>
        </div>
      </div>
    </div>
  </ng-container>
</div>
